import Axios from "@/plugins/Axios";
import FichaIndividualCAee from "../Models/FichaIndividualCAee";

export class EducacaoInclusivaService {
  async syncAll(form) {
    const response = await Axios().post(`educacao-inclusiva`, form);
    const payload = response.data;
    return payload;
  }

  async lancar(form) {
    await Axios().post(`educacao-inclusiva/salvar-relatorio`, form);
  }

  async carregarFichaDeDiarioAtendimento(matricula_id, gestaoDeAulasId) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-ficha-de-diario-atendimento/${matricula_id}/${gestaoDeAulasId}`
    );
    const payload = new FichaIndividualCAee(response.data);

    return payload;
  }

  async lancarFichaDeDiarioAtendimentoEdit(form) {
    await Axios().post(`educacao-inclusiva/salvar-ficha-de-diario-atendimento-edit`, form);
  }

  async mudarPresenca(id, justificativa) {
    await Axios().post(`educacao-inclusiva/presenca/${id}`, { justificativa });
  }

  async mudarConfirmacao(id) {
    await Axios().get(`educacao-inclusiva/confirmacao/${id}`);
  }

  async carregarFichaDeDiarioAtendimentoEdit(id) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-ficha-de-diario-atendimento-edit/${id}`
    );

    return new FichaIndividualCAee(response.data);
  }

  async deletar(ficha) {
    const response = await Axios().delete(`educacao-inclusiva/${ficha.id}`);
    const fichaDeletada = response.data;
    return fichaDeletada;
  }

  async pesquisarAtendimentosEmConflitos(data, horario_id, matricula_id, atendimento_id = null) {
    const response = await Axios().get(
      `educacao-inclusiva/verificar-atendimento-existente/${data}/${parseInt(
        horario_id,
        10
      )}/${parseInt(matricula_id, 10)}/${parseInt(atendimento_id, 10)}`
    );
    return response;
  }

  async carregarPlanejamentoMensalAEE(matricula_id, gestao_id, mes_id) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-planejamento-mensal-caee/${matricula_id}/${gestao_id}/${mes_id}`
    );
    return response.data;
  }

  async salvarPlanejamentoMensalCAEE(form) {
    await Axios().post(`educacao-inclusiva/salvar-planejamento-mensal-caee`, form);
  }

  async carregarPlanoCAEE(matricula_id, gestao_id, bimestre) {
    const response = await Axios().get(
      `educacao-inclusiva/carregar-plano-caee/${matricula_id}/${gestao_id}/${bimestre}`
    );
    return response.data;
  }

  async salvarPlanoCAEE(form) {
    await Axios().post(`educacao-inclusiva/salvar-plano-caee`, form);
  }

  // Planejamentos Semestrais
  async carregarPlanejamentosSemestrais(matricula_id, gestao_id) {
    const response = await Axios().get(
      `educacao-inclusiva/planejamentos-semestrais/${matricula_id}/${gestao_id}`
    );
    return response.data;
  }

  async salvarPlanejamentoSemestral(formData) {
    await Axios().post(`educacao-inclusiva/salvar-planejamento-semestral`, formData);
  }

  async deletarPlanejamentoSemestral(id) {
    await Axios().delete(`educacao-inclusiva/planejamento-semestral/${id}`);
  }

  async baixarPlanejamentoSemestral(id, nomeArquivo) {
    const response = await Axios()
      .get(`educacao-inclusiva/planejamento-semestral/${id}/download`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = nomeArquivo;
        link.click();
      });
    return response;
  }
}
export default new EducacaoInclusivaService();
